import { action } from 'typesafe-actions';
import {
  WalletExpirationSettingsTypes,
  WalletExpirationSettingsInterface,
} from './types';

// Get Wallet Expiration Settings
export const getWalletExpirationSettingsRequest = (payload: object) =>
  action(WalletExpirationSettingsTypes.GET_WALLET_EXPIRATION_SETTINGS_REQUEST, payload);
export const getWalletExpirationSettingsSuccess = (payload: {
  walletExpirationSettingsData: WalletExpirationSettingsInterface;
}) =>
  action(
    WalletExpirationSettingsTypes.GET_WALLET_EXPIRATION_SETTINGS_SUCCESS,
    payload,
  );
export const getWalletExpirationSettingsFailure = () =>
  action(WalletExpirationSettingsTypes.GET_WALLET_EXPIRATION_SETTINGS_FAILURE);

// Update Wallet Expiration Settings
export const updateWalletExpirationSettingsRequest = (payload: object) =>
  action(
    WalletExpirationSettingsTypes.UPDATE_WALLET_EXPIRATION_SETTINGS_REQUEST,
    payload,
  );
export const updateWalletExpirationSettingsSuccess = (payload: {
  walletExpirationSettingsData: WalletExpirationSettingsInterface;
}) =>
  action(
    WalletExpirationSettingsTypes.UPDATE_WALLET_EXPIRATION_SETTINGS_SUCCESS,
    payload,
  );
export const updateWalletExpirationSettingsFailure = () =>
  action(
    WalletExpirationSettingsTypes.UPDATE_WALLET_EXPIRATION_SETTINGS_FAILURE,
  );
